import { useState } from "react";
import { useRoles } from "@/hooks/useRoles";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { Loading } from "@/components/Page/Loading";
import { Forbidden } from "@/components/Page/Forbidden";
import { ShopConfigAuditTable } from "@/components/ShopConfigAudit/ShopConfigAudit.table";
import { ShopConfigAuditPanel } from "@/components/ShopConfigAudit/ShopConfigAuditPanel";
import { StatusLegend } from "@/components/ShopConfigAudit/StatusLegend";
import { useAuditSelection } from "@/components/ShopConfigAudit/useAuditSelection";
import { ShopAuditRow } from "@/hooks/queries/useShopConfigAuditRows";
import { AuditFilter } from "@/lib/shopConfigAuditView";

const ShopConfigAuditPage = () => {
  const { isSuperAdmin, isInitialized } = useRoles();
  useIsSuperAdmin();
  const [rows, setRows] = useState<ShopAuditRow[]>([]);
  // Held here, not in the panel: paging empties `rows` for a moment, which
  // unmounts the panel; the chosen tab must survive that.
  const [filter, setFilter] = useState<AuditFilter>("issues");
  const { selectedRow, select, close } = useAuditSelection(rows);

  if (!isInitialized) return <Loading />;
  if (isInitialized && !isSuperAdmin) return <Forbidden />;

  return (
    <div className="flex min-h-full flex-col lg:h-full lg:flex-row">
      <div className="flex min-w-0 flex-1 flex-col gap-5 p-5 lg:overflow-y-auto">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <h1 className="text-2xl font-medium">Shop Config Audit</h1>
          <StatusLegend />
        </div>
        <div className="overflow-x-auto">
          <ShopConfigAuditTable
            selectedShopId={selectedRow?.shop.id ?? null}
            onSelectRow={select}
            onRowsChange={setRows}
          />
        </div>
      </div>
      {selectedRow && (
        <ShopConfigAuditPanel
          shopId={selectedRow.shop.id}
          shopName={selectedRow.shop.name}
          audit={selectedRow}
          filter={filter}
          onFilterChange={setFilter}
          onClose={close}
        />
      )}
    </div>
  );
};

export default ShopConfigAuditPage;
